<template>
  <ul>
    <li v-for="(item,index) in list" :key="index" class="flex-b-c d-i">
      <div class="d-i-name">{{$t(item.i18n)}}</div>
      <i style="padding: 0px 8px 0px 4px;">:</i>

      <div class="d-i-value" v-if="item.screen">
        <text-scroll :value="deviceInfo[item.value]?deviceInfo[item.value]:handleValue(item.key)" />
      </div>
      <div class="d-i-value ellipsis-1" v-else>
        <el-tooltip effect="dark" :content="deviceInfo[item.value]?deviceInfo[item.value]:handleValue(item.key)" placement="top" v-if="item.tooltip">
          <span>{{deviceInfo[item.value]?deviceInfo[item.value]:handleValue(item.key)}}</span>
        </el-tooltip>
        <template v-else>
          {{ deviceInfo[item.value]?deviceInfo[item.value]:handleValue(item.key) }}
        </template>
      </div>
    </li>
  </ul>
</template>

<script>

import { dateFormat, timeFormatting, msFormatting } from "@/assets/scripts/dateFormatting.js";

import TextScroll from "./TextScroll";
import timelines from '@static/data/timezones.json';

const color = [];
const list = [
  { key: "设备名称", value: "name", color: "", tooltip: true, i18n: 'ctcdde1' },
  // { key: "屏幕类型", value: "type_remark", color: "", i18n: 'ctcdde2' },
  { key: "分辨率", value: "size_remark", color: "", i18n: 'ctcdde3' },
  { key: "版本号", value: "system_version", color: "", icon: "", i18n: 'ctcdde4' },
  { key: "系统信息", value: "", color: "", icon: "", screen: true, i18n: 'ctcdde5' },
  { key: "备注", value: "remark1", color: "", i18n: 'ctcdde6' },
  { key: "安装日期", value: "", color: "", i18n: 'ctcdde7' },
  { key: "运行状态", value: "", color: "", i18n: 'ctcdde8' },
  { key: "正在播放", value: "programName", color: "", tooltip: true, i18n: 'ctcdde9' },
  { key: "盒子时钟", value: "", color: "", tooltip: true, i18n: 'ctcdde10' },
  { key: "当前时区", value: "", color: "", screen: true, i18n: 'ctcdde11' },
  { key: "运行时间", value: "", color: "", i18n: 'ctcdde12' },
  { key: "定时指令", value: "定时指令", color: "", i18n: 'ctcdde13' },
  { key: "定时播放", value: "定时播放", color: "", i18n: 'ctcdde14' },
  { key: "同步播放", value: "同步播放", color: "", i18n: 'ctcdde15' },
  { key: "信号源", value: "", color: "", i18n: 'ctcdde16' },
  { key: "内存空间", value: "", color: "", i18n: 'ctcdde17' },
  { key: "IP地址", value: "", color: "", i18n: 'ctcdde18' },
  { key: "云看护", value: "cloudRebootStatus", color: "", i18n: 'ctcdde19' },
  { key: "最近心跳", value: "", color: "", tooltip: true, i18n: 'ctcdde20' },
  { key: "设备语言", value: "languages", color: "", i18n: 'ctcdde21' },
];
export default {
  name: 'DeviceInfo',
  props: {
    currentDetail: {
      type: Object,
      default: null
    },
    deviceInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      list,
      color,
      timelines
    }
  },
  methods: {
    handleValue(key) {
      const {
        // screenWidth = '',
        // screenHeight = '',
        run_state,
        installation,
        last_heartbeat,
        runningTime,
        total_uptime,
        curTimeMills,
        signalSourceValue,
        usableSpace,
        totalSpace,
        freeMem,
        totalMem,
        useCpu,
        deviceVersion,
        timeZoneId,
        ip
      } = this.deviceInfo;
      // console.log(curTimeMills);
      switch (key) {

        case "安装日期": {
          if (!installation) { return '---'; }
          if (!parseInt(installation)) { return '---'; }
          const d = new Date(parseInt(installation));
          return `${dateFormat(d)}  ${timeFormatting(d)}`;
        }
        // case "分辨率": return (screenWidth && screenHeight) ? `${screenWidth}X${screenHeight}` : '---';
        case "运行状态": {
          switch (run_state) {
            case 0: return this.$t('ctcdde24');
            case 8: return this.$t('ctcdde25');
            default:
              return this.$t('ctcdde26');
          }
        }
        // return ['离线', '播放', '休眠', '登录', '下载', '停止', '重启', '开屏', '关屏'][run_state];

        case "最近心跳": {
          if (parseInt(last_heartbeat) === 0) { return '---'; }
          const d = new Date(last_heartbeat * 1000);
          return `${dateFormat(d)}  ${timeFormatting(d)}`;
        }
        case "当前时区": {
          let timelinesItem = this.timelines.find((time) => time.id === timeZoneId);
          return timelinesItem ? timelinesItem.label : '---';
        }
        case "盒子时钟": {
          if (!curTimeMills) { return '---'; }
          const d = new Date(curTimeMills);
          return `${dateFormat(d)}  ${timeFormatting(d)}`;
        }
        case "运行时间": {
          const runningTimeStr = runningTime ? msFormatting(runningTime) : '---';
          const total_uptimeStr = total_uptime ? msFormatting(total_uptime) : '---';
          return `${runningTimeStr}/${total_uptimeStr}`;
        }
        case "信号源": return signalSourceValue !== undefined ? ["---", this.$t('ctcdde27'), this.$t('ctcdde28'),this.$t('ctcdde29')][signalSourceValue] : '---';
        case "内存空间": {
          return `${(usableSpace / 1024).toFixed(2)}GB / ${(totalSpace / 1024).toFixed(2)}GB`;
        }
        case "系统信息": {
          return `${this.$t('ctcdde30')}: ${deviceVersion}  cpu: ${useCpu}%  ${this.$t('ctcdde31')}:${(freeMem / 1024).toFixed(1)}MB/${(totalMem / 1024).toFixed(1)}MB`;
        }
        case "IP地址": {
          return this.deviceInfo['有线网络'] ? this.deviceInfo['有线网络'] : ip ? ip : "---";
        }
        default:
          return "---";
      }
    }
  },
  watch: {
    deviceInfo() {
      // console.log(this.deviceInfo);
    },
  },
  components: {
    TextScroll
  }
}
</script>

<style lang="scss" scoped>
.d-i {
  width: 100%;
  max-height: 16px;
  padding: 12px 0px;
  border-bottom: 1px solid #fff;
  user-select: none;
  .d-i-name {
    width: 80px;
    text-align: right;
  }
  .d-i-value {
    max-width: 148px;
    width: calc(100% - 80px - 16px);
    cursor: pointer;
  }
}
</style>